export default "__VITE_ASSET__D59vzKVy__"